/* Collection hero "Shop <title>" button -> smooth-scroll to the product grid.
   The v7.5 hero button links to #shopify-section-product-grid, but in a JSON
   template Shopify renders the grid id as shopify-section-template--<hash>__product-grid,
   so the native anchor never resolves. This intercepts the click and scrolls to the real grid. */
(function () {
  function findGrid() {
    return document.querySelector('[id$="__product-grid"], [id*="__product-grid"]')
        || document.getElementById('shopify-section-product-grid')
        || document.querySelector('.main-collection-products, #main-collection, .collection__products, .main-collection');
  }
  function headerOffset() {
    var els = document.querySelectorAll('header, .section-header, #shopify-section-header, [class*="header"]');
    var max = 0;
    els.forEach(function (el) {
      var s = getComputedStyle(el);
      if (s.position === 'fixed' || s.position === 'sticky') {
        var h = el.getBoundingClientRect().height;
        if (h > max && h < 200) max = h;
      }
    });
    return (max || 90) + 12;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#shopify-section-product-grid"]');
    if (!a) return;
    var grid = findGrid();
    if (!grid) return;            /* fall back to default if nothing found */
    e.preventDefault();
    var y = grid.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }, false);
})();
